import { Check, Circle } from 'lucide-react';
import { avaliarSenha } from '@/features/auth/senha';
import { cn } from '@/lib/utils';

/**
 * Lista os critérios de senha e marca os já atendidos.
 *
 * Cada item combina ícone e texto: o estado nunca depende só da cor.
 */
export function CriteriosSenha({ senha }: { senha: string }) {
  const { criterios, rotulo } = avaliarSenha(senha);

  return (
    <div className="flex flex-col gap-1.5">
      <ul className="flex flex-col gap-1">
        {criterios.map((criterio) => (
          <li
            key={criterio.texto}
            className={cn(
              'flex items-center gap-1.5 text-xs',
              criterio.atendido ? 'text-sucesso' : 'text-silenciado-texto',
            )}
          >
            {criterio.atendido ? (
              <Check className="size-3.5 shrink-0" aria-hidden="true" />
            ) : (
              <Circle className="size-3.5 shrink-0" aria-hidden="true" />
            )}
            {criterio.texto}
            <span className="apenas-leitor-tela">
              {criterio.atendido ? ' — atendido' : ' — pendente'}
            </span>
          </li>
        ))}
      </ul>

      {senha.length > 0 && (
        <p className="text-silenciado-texto text-xs" aria-live="polite">
          Força da senha: <strong>{rotulo}</strong>
        </p>
      )}
    </div>
  );
}
